"use client";

import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import { openChatWidget } from "@/components/common/footer-scripts";
import { cn } from "@/lib/utils";

export const FooterOpenChatButton = ({ className }: { className?: string }) => {
  const t = useTranslations("footer");

  return (
    <Button
      className={cn(
        "w-full bg-brand-green2-300 text-brand-white transition-colors duration-200 hover:bg-brand-green2-300/90",
        className,
      )}
      onClick={openChatWidget}
      size="wide"
      type="button"
    >
      {t("openChat")}
    </Button>
  );
};
